export const CTNY = {
    standardUnitListing: {
        unitType: {
            callSiteManager: 'Call 0437505638'
        }
    }
}